var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublished({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Send",
    d: "M13.835,2.165a.563.563,0,0,1,.129.6l-3.8,10.863a.562.562,0,0,1-1.045.043L7.03,8.97l-4.7-2.087a.562.562,0,0,1,.043-1.045l10.864-3.8a.563.563,0,0,1,.6.129ZM11.3,3.907,4.087,6.431,7.332,7.873ZM8.127,8.668,12.093,4.7l-2.524,7.21Z",
    transform: "translate(-2 -2)",
    fill: "#888",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublished);
export default __webpack_public_path__ + "static/media/published.517e2e20052323f99dba0b76338e4240.svg";
export { ForwardRef as ReactComponent };